import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { ArchiveStatsModels } from '@models/archive-stats.models';
import { ArchiveStatsActions } from './archive-stats.action-types';


export interface ArchiveStatsState extends EntityState<ArchiveStatsModels.Document> {
  initialLoaded: boolean;// show loader until first loading happening
  notEmpty: boolean; //show no Data if result empty
  listLoading: boolean; //show loaded each time when query params changed,
  requestFilter: ArchiveStatsModels.RequestFilter;

  /**
   * Paging required
   */
  latestTs: number;
  isLastPage: boolean;

}

export const archiveStatAdapter: EntityAdapter<ArchiveStatsModels.Document> = createEntityAdapter<ArchiveStatsModels.Document>({
  selectId: (document: ArchiveStatsModels.Document) => document._id,
});

const initialState: ArchiveStatsState = archiveStatAdapter.getInitialState({
  initialLoaded: true,
  notEmpty: false,
  listLoading: false,
  requestFilter: ArchiveStatsModels.defaultRequestFilter,

  latestTs: null,
  isLastPage: false,
});

export const { selectAll, selectEntities, selectIds, selectTotal } = archiveStatAdapter.getSelectors();


export const archiveStatsStateReducer = createReducer(
  initialState,
  on(ArchiveStatsActions.resetToInitialState, state => {
    return {
      ...initialState,
    };
  }),
  on(ArchiveStatsActions.setListLoader, (state, { loading }) => {
    return {
      ...state,
      listLoading: loading,
    };
  }),
  on(ArchiveStatsActions.getArchiveStatsSuccess, (state, { items }) => {
    const totalLength = items.length;
    if (!totalLength) {
      return archiveStatAdapter.addMany(items, {
        ...state,
        initialLoaded: false,
      });
    } else {
      return archiveStatAdapter.addMany(items, {
        ...state,
        isLastPage: totalLength < ArchiveStatsModels.PAGE_LIMIT,
        latestTs: items[totalLength - 1].timestamp,
        initialLoaded: false,
      });
    }
  }),
  on(ArchiveStatsActions.getArchiveStatsFail, (state) => {
    return {
      ...state,
      initialLoaded: false,
      isLastPage: true,
    };
  }),
  on(ArchiveStatsActions.setCalendarFilter, (state, { date }) => {
    return {
      ...state,
      requestFilter: {
        ...state.requestFilter,
        dateRange: date,
      },
    };
  }),
  on(ArchiveStatsActions.setStatusFilter, (state, { status }) => {
    return {
      ...state,
      requestFilter: {
        ...state.requestFilter,
        status,
      },
    };
  }),
  on(ArchiveStatsActions.setOrgIdFilter, (state, { orgId }) => {
    return {
      ...state,
      requestFilter: {
        ...state.requestFilter,
        orgId,
      },
    };
  }),
  on(ArchiveStatsActions.resetEntities, (state) => {
    return archiveStatAdapter.removeAll({
      ...state,
      isLastPage: initialState.isLastPage,
      latestTs: initialState.latestTs,
    });
  }),
);

